<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>账号列表</h3>
                </el-col>
                <el-col :span="2" v-if="Role === '1'">
                    <el-button type="info" @click="handleAdd">添加</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="fetchList">
            <el-table-column prop="userId" label="账号ID">
            </el-table-column>
            <el-table-column prop="username" label="用户名">
            </el-table-column>
            <el-table-column prop="nickName" label="姓名">
            </el-table-column>
            <el-table-column prop="phoneNumber" label="电话">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="角色">
                <div>
                    <span>{{ row.power === 0 ? '普通' : '高级'}}</span>
                </div>
            </el-table-column>
            <el-table-column prop="creatorId" label="创建人">
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="created" label="创建时间">
                <span>{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" width="150" label="操作" v-if="Role === '1'">
                <span>
                                                    <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                                                    <el-button @click="handleEditPsd($index, row)" type="text" size="small">修改密码</el-button>
                                                    <el-button @click="handleDelete($index, row)" type="text" size="small">删除</el-button>
                                                	<!-- <el-button @click="handleDelete($index, row)" type="text" size="small">删除</el-button> -->
                                                </span>
            </el-table-column>
        </el-table>
    
        <el-dialog title="添加账号" v-model="addTag">
            <el-form :model="userForm" ref="userForm" :rules="addTagRules" label-width="120px">
                <el-form-item label="用户名" label-width="120px" prop="username">
                    <el-input v-model="userForm.username" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="姓名" label-width="120px" prop="nickName">
                    <el-input v-model="userForm.nickName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" label-width="120px" prop="phoneNumber">
                    <el-input v-model="userForm.phoneNumber" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" label-width="120px" prop="password">
                    <el-input v-model="userForm.password" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="power">
                    <el-radio-group v-model="userForm.power">
                        <el-radio label="管理员" value="1"></el-radio>
                        <el-radio label="运营" value="0"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addTag = false">取 消</el-button>
                    <el-button type="primary" @click="handleNewTag">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="修改密码" :visible.sync="dialogPsdVisible">
            <el-form :model="psdForm" label-width="150px">
                <el-form-item label="密码">
                    <el-input v-model="psdForm.psd" auto-complete="off"></el-input>
                </el-form-item>
    
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogPsdVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitNewPsd">确定修改</el-button>
            </div>
        </el-dialog>
    
        <el-dialog title="编辑账号" v-model="editTag">
            <el-form :model="userForm" ref="userForm" :rules="addTagRules" label-width="120px">
                <el-form-item label="用户名" label-width="120px" prop="username">
                    <span>{{userForm.username}}</span>
                </el-form-item>
                <el-form-item label="姓名" label-width="120px" prop="nickName">
                    <el-input v-model="userForm.nickName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" label-width="120px" prop="phoneNumber">
                    <el-input v-model="userForm.phoneNumber" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色">
                    <el-radio-group v-model="userForm.power">
                        <el-radio label="管理员" value="1"></el-radio>
                        <el-radio label="运营" value="0"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button @click="editTag = false">取 消</el-button>
                    <el-button type="primary" @click="handlePostTag">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    
    </div>
</template>

<script>
    import {
        getProductTags,
        postProductTags,
        patchProductTags,
        deleteProductTags,
        getAccount,
        addAccount,
        deleteAccount,
        patchAccount,
        patchPsd
    } from '../../api/version'
    
    export default {
        data() {
            return {
                Role: sessionStorage.power,
                dialogPsdVisible: false,
                psdForm: {},
                userIds: '',
                fetchList: [],
                addTag: false,
                editTag: false,
                uptoken: {
                    token: sessionStorage.token
                },
                userForm: {
                    username: '',
                    nickName: '',
                    phoneNumber: '',
                    password: '',
                    power: '',
    
                },
                addTagRules: {
                    username: [{
                        required: true,
                        message: '请输入用户名',
                        trigger: 'blur'
                    }],
                    nickName: [{
                        required: true,
                        message: '请输入姓名',
                        trigger: 'blur'
                    }],
                    password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }],
                    power: [{
                        required: true,
                        message: '请选择用户角色',
                        trigger: 'blur'
                    }],
                    phoneNumber: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur'
                    }]
                }
            }
        },
    
        created() {
            //获取商品标签
            getAccount(sessionStorage.userId, JSON.stringify({
                'include': 'creator'
            })).then(res => {
                console.log(res.data)
                this.fetchList = res.data
            }, err => {
                console.log(err)
            })
        },
    
        methods: {
            handleEditPsd(index, row) {
                this.dialogPsdVisible = true
                this.userIds = row.userId
            },
            submitNewPsd() {
                console.log(this.psdForm.psd)
                //提交新密码
                if (this.psdForm.psd) {
                    let data = {
                        password: this.psdForm.psd
                    }
                    patchPsd(sessionStorage.userId, this.userIds, data).then(res => {
                        if (res.data) {
                            this.dialogPsdVisible = false
                            this.$message({
                                message: '成功修改密码',
                                type: 'success'
                            });
                        }
                    }, err => {
                        this.$message.error('修改密码失败')
                    })
                }
            },
            //删除分类
            handleDelete(index, row) {
                //index 索引
                // row 当前数据
                this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fetchList.splice(index, 1)
    
                    deleteAccount(sessionStorage.userId, row.userId).then(res => {
                        if (res.data.count) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    }, err => {
                        this.$message.error('删除失败');
                    })
    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //编辑分类
            handleEdit(index, row) {
                this.editTag = true
                this.userForm = JSON.parse(JSON.stringify(row))
                if (this.userForm.power === 1) {
                    this.userForm.power = '管理员'
                } else {
                    this.userForm.power = '运营'
                }
                
                console.log(row)
            },
            handleAdd() {
                //新建分类按钮
                this.userForm = {
                    username: '',
                    nickName: '',
                    phoneNumber: '',
                    password: '',
                    power: '',
    
                }
                this.addTag = true
            },
            //编辑分类
            handleUpdateTag() {
                this.$refs['tagForm'].validate((valid) => {
                    let data = JSON.parse(JSON.stringify(this.tagForm))
                    delete data.tagId
                    patchProductTags(this.tagForm.tagId, sessionStorage.userId, data).then(res => {
                        //返回新增数据，插入表格中。
                        this.editTag = false
                        this.$message({
                            type: 'success',
                            message: '更新成功!'
                        });
                    }, err => {
                        this.$message.error('新增分类失败');
                    })
    
                })
            },
            handlePostTag() {
                //编辑分类提交按钮
                this.$refs['userForm'].validate((valid) => {
                    if (!this.userForm.power) {
                        this.$message.error('请选择用户角色')
                    } else {
                        let data = JSON.parse(JSON.stringify(this.userForm))
                        let id = data.userId
                        console.log(data.power)
                        if (data.power === '管理员') {
                            data.power = 1
                        } else {
                            data.power = 0
                        }
                        delete data.password
                        delete data.userId
                        patchAccount(sessionStorage.userId, id, data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: 'success',
                                    message: '更新成功!'
                                });
                                this.editTag = false
                                getAccount(sessionStorage.userId, JSON.stringify({
                                    'include': 'creator'
                                })).then(res => {
                                    console.log(res.data)
                                    this.fetchList = res.data
                                }, err => {
                                    console.log(err)
                                })
    
                            }else{
                                console.log('ff')
                            }
                        }, err => {
                            if(err.response.data.error.statusCode === '422') {
                                this.$message.error('姓名已存在，请修改后，在提交')
                            }
                        })
                    }
    
                })
            },
            handleNewTag() {
                //新建分类提交按钮
                this.$refs['userForm'].validate((valid) => {
                    if (!this.userForm.power) {
                        this.$message.error('请选择用户角色')
                    } else {
                        let data = JSON.parse(JSON.stringify(this.userForm))
                        console.log(data.power)
                        if (data.power === '管理员') {
                            data.power = 1
                        } else {
                            data.power = 0
                        }
                        data.email = `admin_${data.username}@shareplay.cc`
                        addAccount(sessionStorage.userId, data).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: 'success',
                                    message: '创建成功!'
                                });
    
                                getAccount(sessionStorage.userId, JSON.stringify({
                                    'include': 'creator'
                                })).then(res => {
                                    console.log(res.data)
                                    this.fetchList = res.data
                                }, err => {
                                    console.log(err)
                                })
    
                                this.addTag = false
                            }
                        }, err => {
                            if(err.response.data.error.statusCode === '422') {
                                this.$message.error('姓名已存在，请修改后，在提交')
                            }
                        })
                    }
    
                })
            },
    
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// AccountList.vue?a5475c52